import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PerfilEnum } from '../../enums/perfil-enum';
import { ConfirmedValidator } from '../../validators/confirmed.validator';
import { Usuario } from '../usuario';
import { UsuarioService } from '../usuario.service';

@Component({
  selector: 'app-usuario-maintenance',
  templateUrl: './usuario-maintenance.component.html',
  styleUrls: ['./usuario-maintenance.component.css']
})
export class UsuarioMaintenanceComponent implements OnInit {

  id: string;

  isUpdate: string;

  isInfo: boolean = false;

  isNew: boolean = false;

  usuario: Usuario;

  formularioDeUsuario: FormGroup;

  tituloCrud: string = '';

  public listaPerfis: string[] = [];

  constructor(private usuarioService: UsuarioService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.usuario = new Usuario();

    this.formularioDeUsuario = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(6)]],
      username: ['', [Validators.required, Validators.minLength(3)]],
      perfil: ['', [Validators.required]],
      enabled: new FormControl(true),
      password: [''],
      confirmPassword: [''],
      novoPassword: ''
    }, {
      validator: ConfirmedValidator('password', 'confirmPassword')
    });
  }

  ngOnInit() {

    if (this.id) {
      this.isNew = false;
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Usuário';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Usuário';
      }
    } else {
      this.isNew = true;
      this.tituloCrud = 'Criar Usuário';
    }

    this.listarPerfis();
  }

  save() {

    this.usuario = this.formularioDeUsuario.value;

    if (this.usuario.password) {
      this.usuario.novoPassword = this.usuario.password;
    }

    if (!this.usuario.enabled) {
      this.usuario.enabled = false;
    }

    if (this.isNew) {
      this.usuarioService
        .criar(this.usuario).subscribe(() => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.usuarioService.atualizar(this.usuario, this.id)
        .subscribe(() => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/usuarios']);
  }

  get formControl() {
    return this.formularioDeUsuario.controls;
  }

  listarPerfis() {
    let usuarioLogado = JSON.parse(localStorage.getItem('currentUser') || '{}');

    this.usuarioService.listarPerfisPorPerfilUsuario(usuarioLogado.perfil)
      .subscribe(data => {
        // console.log(data)
        this.listaPerfis = data;

        this.configurarForm();
      }, error => {
        console.log(error);
      });
  }

  configurarForm(): void {
    if (!this.isNew) {

      this.usuario = history.state.usuario;

      if (this.usuario) {

        this.usuario.password = '';
        this.usuario.confirmPassword = '';

        this.formularioDeUsuario.setValue(this.usuario);

        let currentPerfil = this.listaPerfis.filter(perfil => perfil == this.usuario.perfil)[0];
        this.formularioDeUsuario.controls.perfil.patchValue(currentPerfil);
        this.formularioDeUsuario.controls.username.disable();

        this.cd.detectChanges();

        if (this.isUpdate == 'N') {
          this.formularioDeUsuario.disable();
        }
      }
    } else {
      this.formularioDeUsuario.controls.password.setValidators(Validators.required);
      this.formularioDeUsuario.controls.confirmPassword.setValidators(Validators.required);

      this.formularioDeUsuario.setValue({
        name: '',
        username: '',
        perfil: '',
        enabled: true,
        password: '',
        confirmPassword: '',
        novoPassword: ''
      });
    }
  }
}
